import React from 'react'
import logo from '../../../assets/static/logo-catarinense.png'

const LogotipoCatarinense = () => <img src={logo} alt="Logotipo Catarinense" />

export default LogotipoCatarinense
